import { render } from "./SendEmail.vue?vue&type=template&id=05d75af9&scoped=true&xmlns%3Aslot=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d75af9"]])

export default __exports__